import React, { useEffect, useState } from 'react'
import axios from 'axios'

import {
  useDispatch,
  useSelector
} from 'react-redux'

import {
  Link,
  useNavigate
} from 'react-router-dom'

import Navbar from '../Navbar'
import { actions } from '../../../store'

import {
  FiArrowLeft,
  FiCheckCircle,
  FiUser
} from 'react-icons/fi'


export default function EditFullname() {

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {
    currentUser,
    url
  } = useSelector(state => state)

  const [fullname, setFullname] = useState('')
  const [loading, setLoading] = useState(false)

  const [error, setError] = useState('')
  const [message, setMessage] = useState('')


  useEffect(() => {

    if (currentUser?.fullname) {
      setFullname(currentUser.fullname)
    }

  }, [currentUser])


  const saveChanges = async (event) => {

    event.preventDefault()

    const value = fullname.trim()

    setError('')
    setMessage('')


    if (!value) {

      setError(
        'Please enter your full name.'
      )

      return
    }


    if (value.length < 3) {

      setError(
        'Please enter a valid full name.'
      )

      return
    }


    if (
      value === currentUser?.fullname
    ) {

      setError(
        'Your full name has not changed.'
      )

      return
    }


    try {

      setLoading(true)

      const formData =
        new FormData()

      formData.append(
        'fullname',
        value
      )


      const response =
        await axios.post(
          `${url}/auth/edit-fullname`,
          formData,
          {
            headers: {
              Authorization:
                `Bearer ${localStorage.getItem(
                  'access_token'
                )}`
            }
          }
        )


      const data = response.data


      if (
        data.status === 200 ||
        data.message
      ) {

        dispatch(
          actions.updateUser({
            ...currentUser,
            fullname: value
          })
        )


        setMessage(
          data.message ||
          'Full name updated successfully.'
        )


        setTimeout(() => {

          navigate(
            '/dashboard/profile/'
          )

        }, 1200)

        return
      }


      setError(
        data.error ||
        'Unable to update your full name.'
      )


    } catch (err) {

      console.error(
        'Update fullname error:',
        err
      )

      setError(
        err.response?.data?.detail ||
        err.response?.data?.error ||
        'Unable to update your full name.'
      )

    } finally {

      setLoading(false)
    }
  }


  return (

    <div className="
      min-h-screen
      bg-[#F7F9FC]
      font-[Satoshi]
    ">

      <Navbar />


      <main className="
        lg:ml-[15em]
        min-h-screen
      ">

        <div className="
          max-w-3xl
          mx-auto
          px-5
          sm:px-6
          py-8
          lg:py-12
        ">


          <Link
            to="/dashboard/profile/"
            className="
              inline-flex
              items-center
              gap-2
              text-sm
              font-semibold
              text-gray-500
              hover:text-gray-900
              mb-7
              transition
            "
          >
            <FiArrowLeft />

            Back to profile
          </Link>


          <div className="
            bg-white
            border
            border-gray-200
            rounded-3xl
            shadow-sm
            overflow-hidden
          ">


            <div className="
              px-6
              py-6
              lg:px-8
              border-b
              border-gray-100
            ">

              <div className="
                w-12
                h-12
                rounded-xl
                bg-green-50
                text-green-600
                flex
                items-center
                justify-center
                text-xl
                mb-5
              ">
                <FiUser />
              </div>


              <h1 className="
                text-2xl
                font-bold
                text-gray-900
              ">
                Edit full name
              </h1>

              <p className="
                text-sm
                text-gray-500
                mt-2
              ">
                Update the name shown on your RentHub account.
              </p>

            </div>


            <form
              onSubmit={saveChanges}
              className="
                px-6
                py-7
                lg:px-8
              "
            >


              {message && (

                <div className="
                  flex
                  items-center
                  gap-3
                  bg-green-50
                  border
                  border-green-200
                  text-green-700
                  rounded-xl
                  px-4
                  py-3
                  text-sm
                  mb-6
                ">

                  <FiCheckCircle />

                  {message}

                </div>

              )}


              {error && (

                <div className="
                  bg-red-50
                  border
                  border-red-200
                  text-red-600
                  rounded-xl
                  px-4
                  py-3
                  text-sm
                  mb-6
                ">
                  {error}
                </div>

              )}


              <div>

                <label
                  htmlFor="fullname"
                  className="
                    block
                    text-sm
                    font-semibold
                    text-gray-700
                    mb-2
                  "
                >
                  Full name
                </label>


                <input
                  id="fullname"
                  type="text"
                  value={fullname}
                  onChange={(event) =>
                    setFullname(
                      event.target.value
                    )
                  }
                  placeholder="Enter your full name"
                  autoComplete="name"
                  className="
                    w-full
                    h-[52px]
                    px-4
                    border
                    border-gray-300
                    rounded-xl
                    bg-white
                    text-gray-900
                    outline-none
                    transition
                    focus:border-green-500
                    focus:ring-4
                    focus:ring-green-50
                  "
                />

              </div>


              <div className="
                flex
                flex-col-reverse
                sm:flex-row
                sm:justify-end
                gap-3
                mt-8
                pt-6
                border-t
                border-gray-100
              ">

                <Link
                  to="/dashboard/profile/"
                  className="
                    h-12
                    px-5
                    rounded-xl
                    border
                    border-gray-300
                    flex
                    items-center
                    justify-center
                    font-semibold
                    text-sm
                    text-gray-700
                    hover:bg-gray-50
                    transition
                  "
                >
                  Cancel
                </Link>


                <button
                  type="submit"
                  disabled={loading}
                  className="
                    h-12
                    px-6
                    rounded-xl
                    bg-green-600
                    hover:bg-green-700
                    disabled:bg-green-400
                    disabled:cursor-not-allowed
                    text-white
                    text-sm
                    font-bold
                    transition
                    min-w-[145px]
                  "
                >
                  {
                    loading
                      ? 'Saving...'
                      : 'Save changes'
                  }
                </button>

              </div>

            </form>

          </div>

        </div>

      </main>

    </div>
  )
}